// extracted by mini-css-extract-plugin
export var badge = "_hi-2";
export var detailsPanel = "_hi-0";
export var resultRow = "_hi-1";